import { j as t } from "./jsx-runtime-944c88e2.js";
import { T as o, a as p } from "./TabStripTab-5182621d.js";
import "react";
import "./index-efd35e77.js";
import "./package-metadata-a152adb8.js";
import "./index-64063129.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./index.es-6889c727.js";
import "./Animation-154b683d.js";
import "./TransitionGroup-34043d49.js";
import "react-dom";
import "./noop-d627517c.js";
import "./guid-fc0d51fd.js";
import "./keys-029ad48d.js";
const R = (r) => /* @__PURE__ */ t.jsx(o, { ...r }), d = (r) => /* @__PURE__ */ t.jsx(p, { ...r });
export {
  R as TabStrip,
  d as TabStripTab
};
